export default class TabHelper {
  public static getTabListNavId(id: string, index: number) {
    return `${id}-nav-${index}`;
  }
  public static getTabListTabId(id: string, index: number) {
    return `${id}-tab-${index}`;
  }
}
